import React, { useEffect, useState } from "react";
import {  useField } from "formik";
import { Field } from "formik";
// import { Row } from "react-bootstrap";
// import "./General-Text-Input.css";

// Create a text box with error detection using Formik hooks
export const GeneralRadioGroupInput = ({ ...props }) => {
    const [field, meta] = useField(props);

    const [validationCheck, setValidationCheck] = useState("");

    // Sets up bootstrap validation styling
    useEffect(() => {
        if (meta.touched && meta.error) {
            setValidationCheck("is-invalid");
        } else if (meta.touched && !meta.error) {
            setValidationCheck("is-valid");
        }
    }, [meta.touched, meta.error]);

    return (
        <>
            <div className="d-flex flex-row">
                <label className="m-2 fw-bold form-check-label">
                    <Field
                        {...field}
                        {...props}
                        type="radio"
                        // name="veteran"
                        htmlFor={props.id || props.name}
                        value="Yes"
                        style={{
                            scale: "1.2",
                        }}
                        className={"form-check-input " + validationCheck}
                        id="1"
                    />
                    &nbsp;Yes
                </label>
                <label className="m-2 fw-bold form-check-label">
                    <Field
                        {...field}
                        {...props}
                        type="radio"
                        // name="veteran"
                        htmlFor={props.id || props.name}
                        value="No"
                        style={{
                            scale: "1.2",
                        }}
                        className={"form-check-input " + validationCheck}
                        id="2"
                    />
                    &nbsp;No
                </label>
            </div>
            {meta.touched && meta.error ? (
                <div className="text-danger">{meta.error}</div>
            ) : null}
        </>
    );
};
